export const RequiredMessage = 'Required field';
export const MaxCharMessage = (textLimit: number) => `Must not exceed ${textLimit} characters`;
export const DigitsOnlyMessage = 'Must be only digits';
export const EmailMessage = 'Invalid Email';
export const AlphanumericMessage = 'Must be alphanumeric';
export const NotBlankMessage = 'Must not contain blank spaces';
export const TickerMessage = 'Invalid Ticker';
